<template>
  <div class="app-bar">
    <v-app-bar app color="#880E4F" dark>
      <v-btn icon v-if="showBackButton" @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-app-bar-nav-icon
        @click="$emit('hamb-click')"
        v-else
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span @click="$router.push('/')">{{ appName }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <span>{{ userName }}</span>
      <v-btn text @click="onLogout">Déconnexion</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    name: "AppBar",
    computed: {
      ...mapState({
        showBackButton: state => state.showBackButton
      }),

      // Get connected user fullname
      userName() {
        return (
          this.$store.state.user.user.firstname +
          " " +
          this.$store.state.user.user.lastname
        );
      },

      // Show back button if we are on a router match who reclaim it (meta => goback == true)
      showBackButton() {
        return this.$route.matched.reduce((acc, x) => {
          return x.meta.goback !== undefined ? x.meta.goback : acc;
        }, false);
      },

      appName() {
        switch (process.env.VUE_APP_ENV) {
          case "dev":
            return "Alan Dev";
          case "preprod":
            return "Alan Preprod";
          default:
            return "Alan";
        }
      }
    },
    methods: {
      ...mapActions({
        logout: "user/logout"
      }),

      // Perform logout
      async onLogout() {
        await this.logout();
        this.$router.push("/login");
      },

      goBack() {
        const goto = this.$route.matched.some(record => record.meta.goto);
        console.log({ name: this.$route.meta.goto });

        if (goto) {
          this.$router.push({ name: "LocalPatientList" });
        } else {
          this.$router.go(-1);
        }
      }
    }
  };
</script>

<style></style>
